import { Injectable } from '@angular/core';

import { Facet } from '@spartacus/core';
import { FacetCollapseState, FacetService } from '@spartacus/storefront';
import { BehaviorSubject } from 'rxjs';

const VALUE_COUNT = 6;

@Injectable({ providedIn: 'root' })
export class DpFacetService extends FacetService {
  protected initialize(facet: Facet): void {
    facet.topValueCount = facet.topValueCount && facet.topValueCount > 0 ? facet.topValueCount : VALUE_COUNT;
    const topFacets = facet.topValueCount;
    if (facet.name && !this.hasState(facet)) {
      this.facetState.set(
        facet.name,
        new BehaviorSubject({
          topVisible: topFacets,
          maxVisible: topFacets,
        } as FacetCollapseState),
      );
    }
  }
}
